<template>
  <div class="main-container">
    <div v-if="showIntro && empCategoryData.length == 0">
      <tl-header type="h1">Employee Categories</tl-header>
      <div class="row-container center">
        <div class="company-info">
          <br />
          <img class="image" src="@/assets/bands.svg" />
          <div @click="goToEmpPage">
            <img class="closeImage" src="@/assets/close.png" />
          </div>
          <div class="fontStyle">
            <br />
            <br />
            <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae dolorem adipisci, ducimus inventore numquam eaque quos sequi quisquam placeat reprehenderit assumenda excepturi, doloribus dicta voluptas autem deserunt eius rerum harum!</span>
            <div class="divider"></div>
            <br />
            <br />
            <btn text="Get Started" type="secondary" @click="goToEmpPage" />
          </div>
        </div>
      </div>
      <bottom-action-container class="placeAtEnd">
        <btn-skip @navClicked="skip"></btn-skip>
      </bottom-action-container>
    </div>
    <div v-else>
      <crud-emp-categories @displayIntro="goToIntropage" />
    </div>
  </div>
</template>

<script>
import CrudEmpCategories from "./crud-empCategory.vue";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  props: {
    showUpdated: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CrudEmpCategories
  },
  computed: {
    ...mapState("onboard/empCategory", {
      empCategoryData: state => state.data
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    }
  },
  data() {
    return {
      toast: true,
      errmsg: "",
      showIntro: true
    };
  },
  activated() {
    this.fetchEmpCategories();
  },
  methods: {
    ...mapActions("onboard/empCategory/", {
      fetch: "fetchAll"
    }),

    /* function to show intro */
    goToIntropage() {
      this.showIntro = true;
    },

    /* function to hide the intro */
    goToEmpPage() {
      this.showIntro = false;
    },

    /* server call to get employee categries */
    async fetchEmpCategories() {
      try {
        await this.fetch(this.le_id);
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to skip the step */
    skip() {
      this.$router.push(
        `/onboarding/entity/${this.$route.params.entity_index}/preferences`
      );
    }
  }
};
</script>


<style lang="scss" scoped>
.row-container {
  .value {
    margin-right: 0;
  }
}

.image {
  margin-top: 30px;
}

.company-info {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  align-items: flex-start;
  position: relative;
  width: 100%;
}

.closeImage {
  position: absolute;
  float: right;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.building {
  width: 56px;
  height: 58px;
  object-fit: contain;
  margin: 25px 0 0 129px;
}

.fontStyle {
  margin-left: 20px;
  font-family: Montserrat;
  font-size: 16px;
  color: #404040;
}

.divider {
  color: #34c0be;
  border-bottom: 2px solid #34c0be;
  width: 60%;
  margin: 30px 0 0 5px;
}

.placeAtEnd {
  margin-top: 200px;
}
</style>
